module.exports = __webpack_public_path__ + "img/icon-telegram-white.17521ae1.svg";